import { useEffect, useRef, useState } from 'react'
import { primary_color } from '../../../Helper/uiHelper'
import { FAQItem } from '../RaiseTicket/faqList'
import { request } from '../../../Redux/Sagas/requests/api'
import { useSelector } from 'react-redux'
import CMSWidgetModal from '../../CMSWidget/cmsWidgetModal'
import Loader from 'react-loaders'

const queryType = [
  {
    name: 'Query Type1',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    queries: [
      {
        name: 'Query1',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        questions: [
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
        ],
      },
      {
        name: 'Query1',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        questions: [
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
        ],
      },
      {
        name: 'Query1',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        questions: [
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
        ],
      },
    ],
  },
  {
    name: 'Query Type1',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    queries: [
      {
        name: 'Query1',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        questions: [
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
        ],
      },
      {
        name: 'Query1',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        questions: [
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
        ],
      },
      {
        name: 'Query1',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        questions: [
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
          {
            question: 'THis is question1',
            answer: 'this is answer1',
          },
        ],
      },
    ],
  },
]
var controller
const FAQBasedOnQueryType = ({ additionalSetting, searchValue, loading, setLoading }) => {
  const [queryTypes, setQueryTypes] = useState([])
  const [pageInfo, setPageInfo] = useState({})
  const pageSize = additionalSetting?.pagination

  useEffect(() => {
    if (additionalSetting?.faq_type && additionalSetting?.faq_type?.length > 0) {
      setLoading(true)
      request('raise-ticket/get-faq-by-query', 'POST', {
        pageSize,
        searchKey: searchValue,
        faq_type: additionalSetting?.faq_type,
      }).then((res) => {
        if (res?.data?.data) {
          setQueryTypes(res?.data?.data)
          setPageInfo(res?.data)
          setLoading(false)
        }
      })
    }
  }, [searchValue])

  const loadMore = () => {
    request('raise-ticket/get-faq-by-query', 'POST', {
      pageSize,
      page: pageInfo?.current_page + 1,
      searchKey: searchValue,
      faq_type: additionalSetting?.faq_type,
    }).then((res) => {
      if (res?.data?.data) {
        setQueryTypes((data) => {
          return [...data, ...res?.data?.data]
        })
        setPageInfo(res?.data)
      }
    })
  }

  if (loading)
    return (
      <div style={{ textAlign: 'center', marginTop: '3rem' }}>
        <Loader color='#3f6ad8' type='ball-pulse' />
      </div>
    )

  return (
    <div className='mt-4'>
      {queryTypes?.length === 0 && (
        <div className='d-flex align-items-center justify-content-center mt-5'>
          <img src='not_found.png' style={{ width: '20rem' }}></img>
        </div>
      )}
      {queryTypes?.map((type, index) => {
        return (
          <div key={index} style={{ marginBottom: '6rem' }} className='mt-3'>
            <div className='mb-3'>
              {additionalSetting?.query_type_as_heading && (
                <>
                  {' '}
                  <h2 className='font-weight-bold h2 mb-2' style={{ color: primary_color }}>
                    {type.name}
                  </h2>
                  <div className='p mb-5 text-muted' style={{ fontWeight: '100' }} dangerouslySetInnerHTML={{ __html: type.description }}></div>
                </>
              )}
            </div>
            <div className='ml-3'>
              {type.queries?.map((query, index) => {
                return (
                  <div key={'query' + index} className='mb-5 mt-3'>
                    {additionalSetting?.query_as_heading && (
                      <div className='mb-3'>
                        <div className='h4 mb-2' style={{ color: primary_color, fontWeight: '400 !important' }}>
                          {query.name}
                        </div>
                        <div
                          className='p mb-2 text-muted'
                          style={{ fontWeight: '100' }}
                          dangerouslySetInnerHTML={{ __html: query.description }}></div>
                      </div>
                    )}
                    <div className='my-4'>
                      {query?.faqs?.map((item) => {
                        return <FAQItem question={item?.question} answer={item?.answer} />
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}

      {pageInfo?.current_page < pageInfo?.last_page && (
        <div className='mt-4 d-flex justify-content-center'>
          <div
            className='subtitle1 px-4 py-1 cursor-pointer'
            onClick={() => {
              loadMore()
            }}
            style={{ border: `1px solid ${primary_color}`, color: primary_color, borderRadius: '0.3rem' }}>
            Show More
          </div>
        </div>
      )}
    </div>
  )
}

export default FAQBasedOnQueryType
